import axios from 'axios';

const GenericOrganisationForBranchService = {
  search: (endpoint) => axios.get(`${endpoint}`)
};

export default GenericOrganisationForBranchService;
